function stripDiacritics(value = '') {
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

function decodeTemplateEscapes(value = '') {
  return String(value)
    .replace(/\\r/g, '\r')
    .replace(/\\n/g, '\n')
    .replace(/\\t/g, '\t');
}

export function renderPrintTemplate(template, passage) {
  const p = passage || {};

  const rawBirthDate = p.date_naissance ?? p.dateNaissance ?? p.ddn ?? '';

  const ddn = rawBirthDate
    ? new Date(rawBirthDate).toLocaleDateString('fr-FR')
    : '';

const date = rawBirthDate ? new Date(rawBirthDate) : null;

const ddn_jour = date ? String(date.getDate()).padStart(2, '0') : '';
const ddn_mois = date ? String(date.getMonth() + 1).padStart(2, '0') : '';
const ddn_annee = date ? String(date.getFullYear()) : '';
const ddn_annee_courte = ddn_annee ? ddn_annee.slice(-2) : '';

const civilite = p.civilite ?? '';

// Création de la logique pour le champ {{sexe}}
let sexe = '';
if (civilite === 'M.') {
  sexe = 'M';
} else if (civilite === 'Mme.') {
  sexe = 'F';
}

const vars = {
  passageId: p.id ?? '',
  musiqId: p.musiqId ?? p.passage_uid ?? p.musiqID ?? '',

  nom: p.nom ?? '',
  prenom: p.prenom ?? '',

  // Variantes ASCII-safe pour les équipements qui lisent mal l’UTF-8
  nomAscii: stripDiacritics(p.nom ?? ''),
  prenomAscii: stripDiacritics(p.prenom ?? ''),

  dateNaissance: rawBirthDate,
  ddn,
  ddn_jour,
  ddn_mois,
  ddn_annee,
  ddn_annee_courte,

  // alias courts pour composer dans n'importe quel ordre
  JJ: ddn_jour,
  MM: ddn_mois,
  AAAA: ddn_annee,
  AA: ddn_annee_courte,

  // variantes minuscules aussi, histoire d’éviter les jurons admin
  jj: ddn_jour,
  mm: ddn_mois,
  aaaa: ddn_annee,
  aa: ddn_annee_courte,

  todayISO: new Date().toISOString().slice(0, 10),
  civilite,
  sexe,

  raw: p,
};

  const expanded = String(template ?? '').replace(
    /{{\s*([a-zA-Z0-9_.]+)\s*}}/g,
    (_, key) => {
      const path = key.split('.');
      let v = vars;
      for (const k of path) v = v?.[k];
      return v == null ? '' : String(v);
    },
  );

  // Important : transforme les séquences tapées dans l’admin (\t, \n, \r)
  // en vrais caractères de contrôle avant génération du QR / code-barres.
  return decodeTemplateEscapes(expanded);
}